export const VIEW_RECEIPT = 'viewReceipt';
export const REORDER = 'reorderBtn';
export const MY_ACCOUNT = 'myAccount';
export const QUICK_ORDER = 'orderItAgain';
export const ORDER_IT_AGAIN = 'orderAgain';
export const KFC_LOVER = 'kfcLover';
export const WELCOME_TO = 'welcomeTo';
export const KFC_TEXT = 'kfcTxt';
export const REVIEW_ORDER = 'reviewOrder';
export const WELCOME_BACK = 'Welcome Back';
export const SEE_FULL_ORDER_HISTORY = 'seeFullOrderHistory';
export const WELCOME_TEXT = 'welcomeBack';
export const IMAGE_URL = `${process.env.REACT_APP_TENANT_IMAGE_BASE_URL}15895bb59f7b4bb588ee933f8cd5344a/images/items/`;
export const CAROUSAL_CONFIG = {
  SPEED: 200,
  SLIDES_TO_SHOW: 3,
  SLIDES_TO_SCROLL: 1,
  BREAKPOINT: 1024,
  SLIDES_TO_SCROLL_MOBILE: 1,
  FADE_CARD_INDEX: 3,
};
export const CONTINUE = 'continue';
export const CANCEL = 'cancel';
